const catalogos = {
    C055Instituciones: "SICUS/Catalogos/GetInstituciones"
}

export default catalogos


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICUS/catalogos/catalogo.js
// module id = HCKS
// module chunks = 2